import React, { useEffect } from 'react';
import currency from 'currency.js';
import { useCart } from './CartContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const PurchaseSidebar = () => {
  const { items, removeItem, loading } = useCart();

  useEffect(() => {
    if (!loading) {
      console.log("CartProvider is working, cartItems:", items);
    }
  }, [items, loading]);

  const calculateSubtotal = () => {
    const subtotalCents = items.reduce((total, item) => total + item.price_cents * item.quantity, 0);
    return currency(subtotalCents, { fromCents: true }).format();
  };

  const renderItem = (cartItem, index) => {
    switch (cartItem.item_type) {
      case 'Product':
        return (
          <tr key={index}>
            <td className='light-text left-align'>{cartItem.item.name}</td>
            <td className='light-text right-align'>{currency(cartItem.price_cents * cartItem.quantity, { fromCents: true }).format()}</td>
            <td><button onClick={() => removeItem(cartItem.id)}>Remove</button></td>
          </tr>
        );
      case 'Registration':
        return (
          <tr key={index}>
            <td className='light-text left-align'>
              <div>{cartItem.item.camp_title}</div>
              <div>{cartItem.item.camp_dates}</div>
              <div>{cartItem.item.camper_name}</div>
            </td>
            <td className='light-text right-align'>{currency(cartItem.price_cents * cartItem.quantity, { fromCents: true }).format()}</td>
            <td><button onClick={() => removeItem(cartItem.id)}>Remove</button></td>
          </tr>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return <p>Loading cart...</p>;
  }

  return (
    <aside id="purchase-sidebar">
      <h2 className="cart-heading"><FontAwesomeIcon icon={faShoppingCart} /> My Cart</h2>
      {items && items.length > 0 ? (
        <table className="cost-summary">
          <tbody>
            {items.map((cartItem, index) => renderItem(cartItem, index))}
            <tr className='total-line'>
              <th>Subtotal</th>
              <td></td>
              <td className='light-text right-align'>{calculateSubtotal()}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr className='total-line'>
              <th>Taxes & Fees</th>
              <td></td>
              <td>Calculated at Checkout</td>
            </tr>
            <tr className='total-line'>
              <th>Total</th>
              <td></td>
              <td>Calculated at Checkout</td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <p className="empty-cart-message">Your cart is empty.</p>
      )}
      <a 
        href="/orders/new" 
        className={`ps-checkout-button ${!items?.length ? 'disabled' : ''}`}
        onClick={(e) => !items?.length && e.preventDefault()}
        aria-disabled={!items?.length}
      >
        Proceed to Checkout
      </a>
    </aside>
  );
};

export default PurchaseSidebar;
